import type { ReactElement } from 'react';
import { useBeforeInstallPrompt } from './useBeforeInstallPrompt.js';
import { useOnlineStatus } from './useOnlineStatus.js';
import { useOfflineBannerClaimed } from './offlineBannerClaim.js';
import { InstallBanner } from './InstallBanner.js';
import { OfflineBanner } from './OfflineBanner.js';
import './pwa.css';

/**
 * Capa de UX PWA, montada una vez en el AppShell. Overlay fijo, app-wide:
 *  - Banner de instalación (gateado por sesiones / dismiss / standalone).
 *  - Aviso slim de offline. Cede el lugar mientras una pantalla muestra su
 *    propio cartel de conexión (ver `offlineBannerClaim.ts`): nunca dos
 *    carteles diciendo "sin conexión" uno arriba del otro.
 * El registro del service worker lo inyecta vite-plugin-pwa (injectRegister:
 * 'auto', registerType: 'autoUpdate') — acá sólo va la UI.
 */
export function PwaLayer(): ReactElement {
  const installPrompt = useBeforeInstallPrompt();
  const { online } = useOnlineStatus();
  const claimed = useOfflineBannerClaimed();

  return (
    <div className="pwa-layer">
      {!online && !claimed ? <OfflineBanner /> : null}
      {installPrompt.shouldShow && online ? (
        <InstallBanner
          iosFallback={installPrompt.isIosSafari}
          onClose={() => installPrompt.dismiss()}
          onInstall={() => {
            if (installPrompt.isIosSafari) return;
            void installPrompt.prompt();
          }}
        />
      ) : null}
    </div>
  );
}
